module.exports = __webpack_public_path__ + "static/img/Instagram.60022ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/social/color/Instagram.png
// module id = wsOm
// module chunks = 134